<template>
  <NodeEditorial v-if="node" v-slot="{ isEditing }" v-bind="node">
    <div v-if="isEditing" class="container">
      Placeholder for the Anura widget.
    </div>
    <ClientOnly v-else>
      <AnuraWidget />
    </ClientOnly>
  </NodeEditorial>
</template>

<script setup lang="ts">
definePageMeta({
  name: 'anura',
  path: '/en/business/media/image-and-video-material',
  drupalFrontendRoute: true,
  languageMapping: {
    en: '/en/business/media/image-and-video-material',
    de: '/de/business/medien/bild-und-videomaterial',
  },
})

const { entity: node } = await useDrupalRouteQuery('editorial')

await renderPageDependencies()
</script>
